<template>
  <div>
    <el-card>
      <div slot="header">PTOs</div>
      <div slot="actions">Total: {{count(approvedPtos)}}</div>
      <ptos-list :ptos="approvedPtos" :showColumns="showColumns"></ptos-list>
    </el-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapActions } from 'vuex';
  import PtosList from '@/components/pto/PtosList';
  import ptoDurationMixin from '@/store/modules/pto/mixins/duration';

  export default {
    name: 'PtosForWeek',
    data() {
      return {
        showColumns: {
          category: true,
          start: true,
          end: true,
          duration: true,
        },
      };
    },
    props: {
      week: {
        type: [Object, Number],
        required: true,
      },
      year: {
        type: [Object, Number],
        required: true,
      },
      userId: {
        required: true,
      },
    },
    components: {
      ptosList: PtosList,
    },
    mixins: [ptoDurationMixin],
    computed: {
      startOfWeek() {
        return moment(`${this.week} ${this.year}`, 'ww gggg').startOf('week');
      },
      endOfWeek() {
        return moment(`${this.week} ${this.year}`, 'ww gggg').endOf('week');
      },
      approvedPtos() {
        return this.$store.getters['entities/ptos/query']()
          .with('category')
          .with('user.profile')
          .where('status', 'approved')
          .where('user_id', this.userId)
          .where(record => moment(record.starts_at).isBetween(this.startOfWeek, this.endOfWeek))
          .get();
      },
      totalPTO() {
        const ms = this.ptosDuration(this.approvedPtos);
        return moment.duration(ms).locale('precise-en').humanize();
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchPtos']),
      count(arr) {
        return arr ? arr.length : 0;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/pto/PtosForWeek.vue